import { render, staticRenderFns } from "./BaseHistoryFileRestore.vue?vue&type=template&id=6446ecc5&scoped=true"
import script from "./BaseHistoryFileRestore.vue?vue&type=script&lang=js"
export * from "./BaseHistoryFileRestore.vue?vue&type=script&lang=js"
import style0 from "./BaseHistoryFileRestore.vue?vue&type=style&index=0&id=6446ecc5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6446ecc5",
  null
  
)

export default component.exports